import { render, staticRenderFns } from "./third-call-record.vue?vue&type=template&id=8e61f88a&scoped=true"
import script from "./third-call-record.vue?vue&type=script&lang=ts"
export * from "./third-call-record.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e61f88a",
  null
  
)

export default component.exports